import { Injectable } from '@angular/core';
import { NavigationButton, NavigationButtonService } from '../navigation-button/navigation-button.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../api/services/auth.service';
import { UserService } from '../../api/services/user.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { User } from '../../api/models/user-model';

@Injectable()
export class ManagementButtonsService implements NavigationButtonService {

  orgId: string;

  buttons: NavigationButton[] = [
    {
      title: 'Client Listing',
      text: 'This is the listing of existing OASIS Clients.',
      icon: '&#xe90d;',
      route: 'client-list',
      role: 'ORGANIZATION_VIEW',
      isSelected: false,
    },
    {
      title: 'Create Client',
      text: 'Create a new OASIS Client in this menu.',
      icon: '&#xe91f;',
      route: 'client-edit',
      role: 'ORGANIZATION_CREATE',
      isSelected: false,
    },
    {
      title: 'User Listing',
      text: `This is the listing of existing OASIS Clients' Users.`,
      icon: '&#xe901;',
      route: 'user-list',
      role: 'USER',
      isSelected: false,
    },
    {
      title: 'Create User',
      text: 'Create a new user of an OASIS Client in this menu.',
      icon: '&#xe91f;',
      route: 'user-edit',
      role: 'USER_CREATE',
      isSelected: false,
    }
  ];

  constructor(private authService: AuthService,
    private userService: UserService
  ) {
  }

  getButtons(): Observable<NavigationButton[]> {
    return this.userService.findUserById(this.authService.getUserId()).flatMap((user: User) => {
      return this.authService.getUserRolesInContext(`ORGANIZATION~${user['Organization ID']}`).map(roles => {
        const filteredButtons = this.buttons.reduce((prev: NavigationButton[], curr: NavigationButton) => {
          return roles.includes(curr.role) ? prev.concat(curr) : prev;
        }, []);
        return filteredButtons;
      });
    });
  }

  getNavigationCommands(button: NavigationButton) {
    if (button.route.includes('-edit')) {
      return ['/management', { outlets: { 'management-content': [button.route, 'new'] } }];
    }
    return ['/management', { outlets: { 'management-content': [button.route] } }];
  }

  onUrlChange(url: string, buttons: NavigationButton[]) {
    return buttons;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/management-buttons.service.ts